import React from 'react';
import { useHistory } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import './AdminHeader.css';

const AdminHeader = ({ title }) => {
  const history = useHistory();

  return (
    <div className="admin-header">
      <div className="header-left">
        <button 
          className="dashboard-nav-btn"
          onClick={() => history.push('/dashboard')}
        >
          <FaHome className="home-icon" />
          Dashboard
        </button>
        <span className="separator">/</span>
        <span className="page-title">{title}</span>
      </div>
    </div>
  );
};

export default AdminHeader; 